/**
 * Minimaler CSV-Parser + Tabellen-Renderer für die Dateivorschau. RFC4180-nah: Felder in
 * Anführungszeichen dürfen Kommas, Zeilenumbrüche und escapte "" enthalten — reicht für
 * die vom Client (convert/xlsx.ts, XLSX.utils.sheet_to_csv) und vom run_python-Tool
 * erzeugten CSV-Dokumente.
 */

/** Sehr breite/lange CSVs würden den Content-Bereich einfrieren — wie die Ergebnis-Deckel
 * an anderen Stellen im Client (Search.tsx: 30 Treffer, chunker.ts: 8 Dokumente/Batch). */
const MAX_CSV_ROWS = 500;

function parseCsv(src: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = "";
  let inQuotes = false;
  let i = 0;
  const n = src.length;

  while (i < n) {
    const c = src[i];
    if (inQuotes) {
      if (c === '"') {
        if (src[i + 1] === '"') {
          field += '"';
          i += 2;
          continue;
        }
        inQuotes = false;
        i++;
        continue;
      }
      field += c;
      i++;
      continue;
    }
    if (c === '"') {
      inQuotes = true;
      i++;
      continue;
    }
    if (c === ",") {
      row.push(field);
      field = "";
      i++;
      continue;
    }
    if (c === "\r") {
      i++;
      continue;
    }
    if (c === "\n") {
      row.push(field);
      rows.push(row);
      row = [];
      field = "";
      i++;
      continue;
    }
    field += c;
    i++;
  }
  // letztes Feld/Zeile, falls die Datei nicht mit einem Zeilenumbruch endet
  if (field !== "" || row.length) {
    row.push(field);
    rows.push(row);
  }
  return rows;
}

export function CsvTable({ src }: { src: string }) {
  const rows = parseCsv(src);
  if (rows.length === 0) return <p className="hint">— leer —</p>;

  const [header, ...body] = rows;
  const shown = body.slice(0, MAX_CSV_ROWS - 1);
  const truncated = body.length > shown.length;

  return (
    <div className="csv-wrap">
      <table className="csv-table">
        <thead>
          <tr>
            {header.map((cell, i) => (
              <th key={i}>{cell}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {shown.map((r, ri) => (
            <tr key={ri}>
              {r.map((cell, ci) => (
                <td key={ci}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {truncated && (
        <p className="hint" style={{ marginTop: 8 }}>
          {`Zeigt ${shown.length} von ${body.length} Zeilen.`}
        </p>
      )}
    </div>
  );
}
